import { DatePicker, Row, Select } from 'antd';
import React, { FC, useCallback, useEffect, useMemo, useState } from 'react';
import { getDefaultDateRanges } from '../../utils/DataFormatterUtils';
import { defaultTimeZone, FILTER_CONFIG_NAMES } from '../../utils/DataConstants';
import moment from 'moment-timezone';

const RANGE_PICKER_DATE_FORMAT = 'MM-DD-YYYY';

require('./OWDateRangePicker.less');

const OWDateRangePicker: FC<any> = ({
	value,
	onChange,
	ranges = getDefaultDateRanges(),
	disabledDate = () => {},
	showTimeZone = false,
}): React.ReactElement => {
	const myTimeZone = moment.tz.guess();
	const myTimeZoneAbbreviation = moment.tz(new Date(), moment.tz.guess()).format('z');
	const defaultTimeZoneAbbreviation = moment.tz(new Date(), defaultTimeZone).format('z');

	const startDate = useMemo(() => value && value.length > 1 && value[0], [value]);
	const endDate = useMemo(() => value && value.length > 1 && value[1], [value]);
	const initialTimeZone = useMemo(
		() => (value && value.length > 2 && value[2]) || myTimeZone,
		[value]
	);

	const [timeZone, setTimeZone] = useState(initialTimeZone);

	const vals = value && [startDate, endDate];

	const handleTimeZoneChange = (tz) => {
		setTimeZone(tz);
		const startDate = (vals && vals[0] && vals[0].tz(tz, true)) || undefined;
		const endDate = (vals && vals[1] && vals[1].tz(tz, true)) || undefined;
		(startDate || endDate) && onChange([startDate, endDate], tz);
	};

	return (
		<Row style={{ flex: 1 }}>
			<DatePicker.RangePicker
				key={
					startDate && endDate ? startDate.format('YYMMDD') + endDate.format('YYMMDD') : undefined
				}
				value={vals}
				ranges={ranges}
				format={RANGE_PICKER_DATE_FORMAT}
				showTime={false}
				onChange={(v) => {
					onChange(v, timeZone);
				}}
				allowEmpty={[true, true]}
				disabledDate={disabledDate}
			/>
			{showTimeZone ? (
				<Select
					className="tz-select"
					style={{
						display: 'inline-flex',
						alignItems: 'center',
						background: '#fafafa',
						whiteSpace: 'nowrap',
						width: 75,
					}}
					defaultValue={initialTimeZone}
					onSelect={handleTimeZoneChange}
				>
					<Select.Option value={myTimeZone} label={myTimeZoneAbbreviation}>
						{myTimeZoneAbbreviation}
					</Select.Option>
					<Select.Option value={defaultTimeZone} label={defaultTimeZoneAbbreviation}>
						{defaultTimeZoneAbbreviation}
					</Select.Option>
				</Select>
			) : null}
		</Row>
	);
};

export default OWDateRangePicker;
